import React, { Component } from "react";

import { Link } from "react-router-dom";
import panel from "../images/panelguy.jpeg";
import wwu from "../images/why.png";
import electric from "../images/Man_on_root.jpg";
import electric2 from "../images/banner3.jpg";

export default class Services extends Component {
  render() {
    return (
      <>
        {/* section 1 */}
        <section className="details">
          <br />
          {/* section */}
          <div className="row">
            <div className="col-6 services ">
              <h6 class="lte-subheader">About Company</h6>
              <br />
              <h3 class="lte-header">JamiTech Energy Solutions Limited</h3>
              <p style={{ textAlign: "left" }}>
                is a leading Nigerian provider of reliable renewable energy. We
                focus on inverter systems, battery backup solutions, and
                high-performance solar installations designed to keep homes and
                businesses running without interruption.
                <br />
                Over the years, we have powered numerous homes, offices, and
                government institutions across the country. We have built a
                reputation for exceptional service, highly trained experts,
                top-notch professional installations and our commitment to
                premium quality.
              </p>
              <br />
              <br />
              <Link className="btn-secondary" to="/about">
                Read More
              </Link>
              <br />
              <br />
              <br />
              <br />
            </div>
            <div className="col-6 fx">
              {/* <Video /> */}
              <img className="wwu" src={wwu} alt="alt" />
            </div>
            <br />
            <br />
          </div>
        </section>

        {/* Section 2 */}
        <section className="details">
          <div className="row">
            <div className="col-5">
              <img src={electric} alt="img" />
              {/* <Video /> */}
            </div>
            <br />
            <div className="col-5 services ">
              <h2>Explore our packages</h2>
              <div className="divider"></div>
              <p>
                Our packages are carefully designed to deliver uninterrupted
                power for homes and offices through our well-sized inverters,
                battery banks, and solar arrays. Each package is tailored with
                special consideration for the appliances to be powered and hours
                of usage.
              </p>
              <p>
                Please explore our available packages using the button below to
                find the option that best matches your energy needs or budget.
              </p>
              <br />
              <Link className="btn-secondary" to="/packages">
                Shop Now
              </Link>
              <br />
            </div>
          </div>
        </section>
        {/* section 3 */}
        <section className="details">
          <div className="row">
            <div className="col-5 services ">
              <p style={{ textAlign: "left" }}>
                <br />
                <br />
                Electricity has become a major challenge for many homes and
                businesses in Nigeria. This has made the need for alternative
                energy sources especially clean, renewable energy. From powering
                homes and offices to hospitals and streetlights, renewable
                energy offers a reliable solution.
              </p>
              <p>
                By switching to renewable energy, you not only reduce your
                running costs but also enjoy greater convenience with
                uninterrupted power supply every day through our premium
                inverter and solar systems.
              </p>

              <br />
              <br />
              <br />
            </div>

            <div className="col-5">
              <img src={panel} alt="img" />
            </div>
          </div>
        </section>

        <section className="details">
          <div className="row">
            <div className="col-5">
              <img src={electric2} alt="img" />
              {/* <Video /> */}
            </div>
            <div className="col-5  ">
              <div class="overview-content">
                <h6>Benefits</h6>

                <p>
                  The benefits of switching to inverter system, battery backup
                  and solar energy can not be overemphasised. Here are some of
                  the benefits.
                </p>
                <ul class="features-list">
                  <li>
                    {" "}
                    <span>Uninterrupted power supply</span>
                  </li>
                  <li>
                    {" "}
                    <span>Zero noise and Zero emission</span>
                  </li>
                  <li>
                    {" "}
                    <span>No daily, weekly or monthly recurring expenses</span>
                  </li>
                  <li>
                    {" "}
                    <span>
                      No wear & tear because there is no mechanical moving parts
                    </span>
                  </li>
                  <li>
                    {" "}
                    <span>Minimal maintenance</span>
                  </li>
                  <li>
                    {" "}
                    <span>Reduced electricity bill</span>
                  </li>
                  <li>
                    {" "}
                    <span>Maximum convenience</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="services">
          <Title title="services" />
          <div className="services-center"></div>
        </section> */}
      </>
    );
  }
}
